var _defs, _path, _polygon, _path2, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ad1e2f;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.37,128.77L242.32,16.21c6.31-3.68,14.11-3.64,20.38.11l188.12,112.41c6.05,3.62,9.76,10.15,9.76,17.2v208.11c0,7.06-3.72,13.6-9.78,17.22l-188.72,112.43c-6.27,3.74-14.08,3.77-20.38.08l-192.34-112.53c-6.14-3.59-9.92-10.18-9.92-17.3v-207.86c0-7.13,3.79-13.72,9.94-17.31Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.24 137.72 252.29 37.25 453.33 137.72 453.33 201.12 252.29 325.93 51.24 188.64 51.24 137.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.5,71.6l39.61-23.43c2.58-1.53,5.78-1.53,8.36,0l39.68,23.44c8.74,5.16,2.19,18.47-7.23,14.71l-33.58-13.42c-1.96-.78-4.14-.78-6.1,0l-33.5,13.41c-9.42,3.77-15.97-9.54-7.24-14.7Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "247.18 322.44 252.29 325.93 256.9 323.06 256.9 204.56 247.18 204.56 247.18 322.44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "453.33 137.72 451.14 136.49 247.18 200.17 248.44 209.81 453.33 145.85 453.33 137.72"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.24 137.72 51.24 141.33 255.71 209.99 256.9 200.34 58.36 133.67 51.24 137.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo11);
export default __webpack_public_path__ + "static/media/logo11.727f1b7a59bcd94d18e5ca45c3c28b9a.svg";
export { ForwardRef as ReactComponent };